import { createTheme } from '@mui/material'

export const muiTheme = createTheme({
	palette: {
		mode: 'dark',
		primary: {
			main: '#edd184',
		},
		secondary: {
			main: '#f50057',
		},
		background: {
			default: '#000000',
			paper: '#424242',
		},
	},
})

// Typescript augmentation of Theme to add additional props
// declare module '@mui/material/styles' {
//     interface Theme {
//       status: {
//         danger: string;
//       };
//     }
//     // allow configuration using `createTheme`
//     interface ThemeOptions {
//       status?: {
//         danger?: string;
//       };
//     }
//   }
